import HttpClienteToken from '../../services/HttpClientToken';

import { TipoFormatoProps } from '../../interfaces/catalogos/TipoFormatoInterface';

export const TipoFormato = () => {

    return new Promise<TipoFormatoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoFormato/', token)
            .then( ({ data } : { data : TipoFormatoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoFormato = () => {

    return new Promise<TipoFormatoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoFormato/ObtenerTipoFormato', token)
            .then( ({ data } : { data : TipoFormatoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoFormato = ( params: TipoFormatoProps ) => {

    return new Promise<TipoFormatoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoFormato/Actualizar', params, token)
            .then( ({ data } : { data : TipoFormatoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoFormato: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoFormato = ( params: TipoFormatoProps ) => {

    return new Promise<TipoFormatoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoFormato/Agregar', params, token)
            .then( ({ data } : { data : TipoFormatoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoFormato: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}